import React from 'react';
import { ICONIFY } from '../../../Constants/iconify';
import { Stack } from '@mui/material';
import CommonNode from './CommonNode';
import NodeWrapper from './NodeWrapper';

function TextareaNode({ data, isConnectable }) {

    return (
        <NodeWrapper nodeId={data?.id}>
            <CommonNode
                data={data}
                icon={ICONIFY.TEXT_AREA}
            />
        </NodeWrapper>
    );
};

export default TextareaNode